import { v4 as uuidV4 } from 'uuid';

class uuid {
  public v4(prefix?: string): string {
    return prefix ? `${prefix}-${uuidV4()}` : uuidV4();
  }
}

const uuidInstance = new uuid();

export default uuidInstance;
